export const TYPEWRITER_TEXT_KEY = "Generate. Integrate. Automate.";

export const HERO_STATS = [
  { value: "10ms", labelKey: "Avg API Response" },
  { value: "99.9%", labelKey: "Uptime SLA" },
  { value: "AWS", labelKey: "Powered Infrastructure" },
  { value: "3+", labelKey: "Odoo Hosting Types" }
];

export const CODE_TABS = [
  { id: "full", labelKey: "Full Syntax Mode" },
  { id: "integrated", labelKey: "Integrated Mode" }
];

export const FEATURES = [
  {
    color: "cyan",
    icon: "⚡",
    titleKey: "Real-Time API Generation",
    descriptionKey:
      "Generate fully documented REST APIs for any Odoo model instantly. No manual coding, no delays."
  },
  {
    color: "purple",
    icon: "🔗",
    titleKey: "AWS Integration Layer",
    descriptionKey:
      "Our managed AWS infrastructure connects to your Odoo instance with sub-10ms latency and automatic scaling."
  },
  {
    color: "pink",
    icon: "☁️",
    titleKey: "Odoo SH & Enterprise",
    descriptionKey:
      "Native support for Odoo SaaS, Odoo SH, Odoo Enterprise, and self-hosted Community instances."
  },
  {
    color: "cyan",
    icon: "🛡️",
    titleKey: "Enterprise Security",
    descriptionKey:
      "OAuth 2.0, API key rotation, IP whitelisting, and end-to-end encryption on every request."
  },
  {
    color: "purple",
    icon: "📊",
    titleKey: "Live Analytics",
    descriptionKey:
      "Monitor API usage, response times, error rates, and integration health in real time."
  },
  {
    color: "pink",
    icon: "🔧",
    titleKey: "Full Syntax & Integrated",
    descriptionKey:
      "Use raw API syntax for maximum control, or let our integrated mode handle auth and routing for you."
  }
];

export const INTEGRATION_CHECKS = [
  "Odoo SH (all versions)",
  "Odoo Enterprise Cloud",
  "Self-Hosted / On-Premise",
  "Local Development Instances"
];

export const INTEGRATION_STEPS = [
  {
    num: "01",
    titleKey: "Connect your Odoo",
    descriptionKey: "Add your instance URL and credentials — we handle the rest"
  },
  {
    num: "02",
    titleKey: "Choose your mode",
    descriptionKey: "Full syntax for developers, Integrated mode for quick deployment"
  },
  {
    num: "03",
    titleKey: "Generate & Deploy",
    descriptionKey: "Your APIs are live in seconds, hosted on AWS global infrastructure"
  }
];

export const PRICING_PLANS = [
  {
    nameKey: "Starter",
    priceKey: "Free",
    priceSuffix: "",
    descriptionKey: "Perfect for testing and small projects",
    highlight: false,
    featureKeys: [
      "100 API calls/day",
      "1 Odoo instance",
      "Full syntax mode",
      "Community support"
    ],
    ctaKey: "Get Started",
    ctaType: "link"
  },
  {
    nameKey: "Developer",
    price: "$29",
    priceSuffixKey: "/mo",
    descriptionKey: "For serious developers and small teams",
    highlight: true,
    popular: true,
    featureKeys: [
      "50,000 API calls/mo",
      "5 Odoo instances",
      "Integrated Mode",
      "AWS integration",
      "Priority support"
    ],
    ctaKey: "Start Free Trial",
    ctaType: "link"
  },
  {
    nameKey: "Enterprise",
    priceKey: "Custom",
    priceSuffix: "",
    descriptionKey: "For large teams and high-volume needs",
    highlight: false,
    featureKeys: [
      "Unlimited API calls",
      "Unlimited instances",
      "Dedicated AWS infra",
      "SLA guarantee",
      "24/7 support"
    ],
    ctaKey: "Contact Sales",
    ctaType: "button"
  }
];

export const NAV_LINKS = [
  { href: "#features", labelKey: "Features" },
  { href: "#integration", labelKey: "Integration" },
  { href: "#pricing", labelKey: "Pricing" },
  { href: "#docs", labelKey: "Docs" }
];

export const FOOTER_LINKS = [
  { href: "#", labelKey: "Privacy" },
  { href: "#", labelKey: "Terms" },
  { href: "#", labelKey: "Status" },
  { href: "#", labelKey: "Contact" }
];
